enum MediaType {
    Video = "video",
    Audio = "audio",
    Image = "image",
    Data = "data",
    VideoStream = "video_stream",
    AudioStream = "audio_stream"
}

class MediaTypeUtil {

    static getId(mediaType: MediaType): number {
        switch (mediaType) {
            case MediaType.Video:
                return 1;

            case MediaType.Audio:
                return 2;

            case MediaType.Image:
                return 3;

            case MediaType.Data:
                return 4;

            case MediaType.VideoStream:
                return 5;

            case MediaType.AudioStream:
                return 6;

            default:
                throw Error(`Unsupported mediaType: ${mediaType}`);
        }
    }

    static getLabel(mediaType: MediaType): string {
        switch (mediaType) {
            case MediaType.Video:
                return "Video";

            case MediaType.Audio:
                return "Audio";

            case MediaType.Image:
                return "Image";

            case MediaType.Data:
                return "Data";

            case MediaType.VideoStream:
                return "Video Stream";

            case MediaType.AudioStream:
                return "Audio Stream";

            default:
                throw Error(`Unsupported mediaType: ${mediaType}`);
        }
    }

    static getShortLabel(mediaType: MediaType): string {
        switch (mediaType) {
            case MediaType.Video:
                return "video";

            case MediaType.Audio:
                return "audio";

            case MediaType.Image:
                return "image";

            case MediaType.Data:
                return "data";

            case MediaType.VideoStream:
                return "stream";

            case MediaType.AudioStream:
                return "audio stream";

            default:
                throw Error(`Unsupported mediaType: ${mediaType}`);
        }
    }

    static getNameForCount(count: number, isList: boolean, mediaType: MediaType): string {
        if (isList) {
            return count == 1 ? "playlist" : "playlists";
        } else {
            switch (mediaType) {
                case MediaType.Video:
                    return count == 1 ? "video" : "videos";
                case MediaType.Audio:
                    return count == 1 ? "audio clip" : "audio clips";
                case MediaType.Image:
                    return count == 1 ? "image" : "images";
                case MediaType.Data:
                    return count == 1 ? "file" : "files";
                case MediaType.VideoStream:
                    return count == 1 ? "video stream" : "video streams";
                case MediaType.AudioStream:
                    return count == 1 ? "audio stream" : "audio streams";
                default:
                    throw new Error(`Unsupported mediaType: ${mediaType}`);
            }
        }
    }

    static isLive(mediaType: MediaType): boolean {
        switch (mediaType) {
            case MediaType.Video:
                return false;
            case MediaType.Audio:
                return false;
            case MediaType.Image:
                return false;
            case MediaType.Data:
                return false;
            case MediaType.VideoStream:
                return true;
            case MediaType.AudioStream:
                return true;
            default:
                throw new Error(`Unsupported mediaType: ${mediaType}`);
        }
    }

    // static getNameForCount(count: number, isList: boolean, navSection: NavSection): string {
    //     const mediaType = NavSectionUtil.getMediaType(navSection);
    //     if(isList){
    //         count == 1 ? "playlist" : "playlists";
    //     } else {
    //         switch (mediaType) {
    //             case MediaType.Video:
    //                 return count == 1 ? "video" : "videos";
    //             case MediaType.Audio:
    //                 return count == 1 ? "audio clip" : "audio clips";
    //             case MediaType.Image:
    //                 return count == 1 ? "image" : "images";
    //             case MediaType.Data:
    //                 return count == 1 ? "file" : "files";
    //             case MediaType.VideoStream:
    //                 return count == 1 ? "video stream" : "video streams";
    //             case MediaType.AudioStream:
    //                 return count == 1 ? "audio stream" : "audio streams";
    //             default:
    //                 throw new Error(`Unsupported mediaType: ${mediaType}`);
    //         }
    //     }
    // }

    static fromFileExt(ext: string): MediaType {
        switch (ext.toLowerCase()) {
            case "3g2":
            case "3gp":
            case "asf":
            case "avi":
            case "flv":
            case "m2t":
            case "m2ts":
            case "mkv":
            case "m4p":
            case "m4v":
            case "mov":
            case "mp2":
            case "mp4":
            case "mpeg":
            case "mpe":
            case "mpg":
            case "mpv":
            case "mts":
            case "mxf":
            case "ogg":
            case "rm":
            case "ts":
            case "vob":
            case "webm":
            case "wmv":
                return MediaType.Video;

            case "aac":
            case "m4a":
            case "mp3":
            case "mpa":
            case "oga":
            case "wma":
                return MediaType.Audio;

            //images
            case "jpg":
            case "tiff":
            case "gif":
            case "bmp":
            case "png":
            case "svg":
            case "webp":
                return MediaType.Image;

            default:
                return MediaType.Data;
        }
    }
}

// class MediaType extends NameLabelType {
//     static Video = {name: "video", label: "Video"};
//     static Audio = {name: "audio", label: "Audio"};
//     static Image = {name: "image", label: "Image"};
//     static Data = {name: "data", label: "Data"};
//     static VideoStream = {name: "video_stream", label: "Video Stream"};
//     static AudioStream = {name: "audio_stream", label: "Audio Stream"};
//
//     protected static Types = [
//         MediaType.Video,
//         MediaType.Audio,
//         MediaType.Image,
//         MediaType.Data,
//         MediaType.VideoStream,
//         MediaType.AudioStream
//     ];
//
//     static fromName(name: string): INameLabelType {
//         return NameLabelType.fromName(name, MediaType.Types);
//     }
//
//     static fromFileExt = (ext: string): object => {
//         switch (ext.toLowerCase()) {
//             case "3g2":
//             case "3gp":
//             case "asf":
//             case "avi":
//             case "flv":
//             case "mkv":
//             case "m4p":
//             case "m4v":
//             case "mov":
//             case "mp2":
//             case "mp4":
//             case "mpeg":
//             case "mpe":
//             case "mpg":
//             case "mpv":
//             case "mxf":
//             case "ogg":
//             case "rm":
//             case "ts":
//             case "vob":
//             case "webm":
//             case "wmv":
//                 return MediaType.Video;
//
//             case "aac":
//             case "m4a":
//             case "mp3":
//             case "mpa":
//             case "oga":
//             case "wma":
//                 return MediaType.Audio;
//
//             //images
//             case "jpg":
//             case "tiff":
//             case "gif":
//             case "bmp":
//             case "png":
//             case "svg":
//             case "webp":
//                 return MediaType.Image;
//
//             default:
//                 return MediaType.Data;
//         }
//     };
//
// }


export {MediaType, MediaTypeUtil};

